export default __webpack_public_path__ + "static/media/camera.32214738.gif";